import Exception from './exception';

export default class ExceptionLoadPageFailed extends Exception {
  constructor(msg: string | undefined) {
    super(msg);
    Object.setPrototypeOf(this, ExceptionLoadPageFailed.prototype);
  }
}